import { render } from "./partition.vue?vue&type=template&id=94158612&scoped=true"
import script from "./partition.vue?vue&type=script&lang=js"
export * from "./partition.vue?vue&type=script&lang=js"

import "./partition.vue?vue&type=style&index=0&id=94158612&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94158612"]])

export default __exports__